<template>
    <div class="select-data">
       <div class="dialog-content">
            <div class="">尺寸【{{ size }}】存在相同的创意规格，至少选择一个进行应用</div>
            <div class="radio-list">
                <el-checkbox-group v-model="selectCheckbox">
                    <p 
                        v-for="item in list"
                        :key="item.key"
                        class="text-item"
                    >
                        <el-checkbox 
                            :label="item.key"
                        >
                            <span class="ellipsis text-label" :title="item.path">{{item.path}}</span>
                        </el-checkbox>
                    </p>
                    
                </el-checkbox-group>
            </div>
       </div>
        <div class="btns tac">
            <el-button @click="handleClose" :disabled="loading">取消</el-button>
            <el-button type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectSizeModal',
    props: [ 'selectData', 'cbs' ],
    data() {
        return {
            selectCheckbox: [],
            loading: false
        }
    },
    computed: {
        size() {
            const {  
                material_type, conf_resolution_ratio, conf_resolution, 
                conf_format, conf_size_name, conf_length, explicit_name ,material_classify_text
             } =this.list[0];
            if (material_type === '1') {
                return `${ material_classify_text }：${conf_resolution}；<=${conf_size_name}；${conf_format}`
            }else {
                return`${ material_classify_text }：${conf_resolution}；<=${conf_size_name}；<=${conf_length}秒；${conf_format}`
            }
        },
        list() {
            return this.selectData.to
        },
        selectConfig() {
            return this.list.filter(v=> this.selectCheckbox.includes(v.key))
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleSubmit() {
            if (!this.selectCheckbox.length) {
                this.$message.error('至少选择一个进行应用')
                return;
            }
            const data = {
                data: this.selectData.values,
                value: this.selectConfig
            };
            if (this.loading) {
                return;
            }
            this.loading = true;
            setTimeout(()=> {
                this.$nextTick(()=>Promise.resolve().then(()=>this.cbs.onSubmit(data)))
            }, 300)
            
        }
    }
}
</script>

<style lang="scss" scoped>
.radio-list {
    margin-top: 12px;
}
.btns {
    margin-top: 15px;
}
.text-item {
    line-height: 30px;
}
.text-label {
    display: inline-block;
    max-width: 500px;
    vertical-align: middle;
}
</style>